import { render } from "./INPUT_FORM_DISPLAY.vue?vue&type=template&id=1f7f721e"
import script from "./INPUT_FORM_DISPLAY.vue?vue&type=script&lang=js"
export * from "./INPUT_FORM_DISPLAY.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Partheas\\Projects\\VDAB\\Code\\qpp-kiosk\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__